@if (errors?.length > 0) {
  <div class="errorMessageContainer"
    >
    <p>{{title}}</p>
    <ul class="row">
      @for (error of errors; track error) {
        <li class="col-12 col-sm-6 col-md-4"
          >
          <span class="errorMessageContainer-dot">.</span>
          <div [innerHTML]="error"></div>
        </li>
      }
    </ul>
  </div>
}
